import Vue from "vue";
import Router from "vue-router";

import Adminareas from "./views/Administrativo/adminareas.vue";
/// import Admingrados from './views/adminGrados.vue'
import Secciones from "./views/Administrativo/Secciones.vue";
import Cursos from "./views/Manager/Cursos.vue";
import Login from "./components/Login.vue";

// Creador de contenido --->
import CreadordeContenido from "./views/Manager/CreadorContenido/CreadorContenido.vue";
//import ContenidoClases from './views/ContenidoDiapositivas/ContenidoClases.vue'

//creando
// import Img from './views/ContenidoDiapositivas/Img.vue'
// import VisordeContenido from './views/VisordeContenido.vue'
// Creador contenido colegio
//import CreadorColegio from './views/CreadorColegio/ContenidoTemas.vue'

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: "/",

  routes: [
    //---------------  MAIN --------------------
    {
      path: "*",
      redirect: "/login",
      component: Login,
      meta: {
        layout: "login_layout",
        breadCrumb: "LOGIN",
      },
    },

    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        layout: "login_layout",
        breadCrumb: "LOGIN",
      },
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue"),
      meta: {
        autentificado: true,
        breadCrumb: "ABOUT",
      },
    },
    {
      path: "/home",
      name: "homeM",
      component: () => import("./views/Home.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "INICIO",
      },
    },
    {
      path: "/mensajeria",
      name: "mensajería",
      component: () => import("./views/Inicio/Mensajeria/Mensajeria.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "INICIO > BUZÓN DE MENSAJERÍA",
      },
    },

    {
      path: "/homeConfig",
      name: "configuracionInicio",
      component: () =>
        import("./views/Inicio/Configuracion/ConfiguracionInicio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "INICIO > CONFIGURACIÓN DE PANTALLA DE INICIO",
      },
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/Dashboard.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "DASHBOARD",
      },
    },

    //--------------- FIN  MAIN --------------------

    //---------------  MANAGER NEW --------------------

    // {
    //   path: "/manager",
    //   name: "manager",
    //   component: () => import("./views/Manager/Login.vue"),
    //   meta: {
    //     layout: "login_layout",
    //     breadCrumb: "LOGIN MÁNAGER",
    //   },
    // },

    {
      path: "/homeManager",
      name: "home",
      component: () => import("./views/Manager/Home.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "INICIO",
      },
    },

    //---------------  MANAGER  --------------------

    //------- manager normativas ministeriales para los grados -------
    {
      path: "/normativasMinisteriales",
      name: "normativasMinisteriales",
      component: () => import('./views/Manager/NormativasMinisteriales/NormativasMinisteriales.vue'),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > NORMATIVAS MINISTERIALES"
      }
    },

    {
      path: "/colegios",
      name: "colegios",
      component: () => import("./views/Manager/Colegio/Colegios.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE COLEGIOS",
      },
    },

    //------- manager licencia -------
    {
      path: "/licencia",
      name: "licencia",
      component: () => import("./views/Manager/Licencia/Licencia.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE LICENCIAS",
      },
    },

    //------- manager usuarios ----------
    {
      path: "/usuariosManager",
      name: "usuarios2",
      component: () => import("./views/Manager/Usuarios.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE USUARIOS",
      },
    },

    //-------tecnico admin perfiles ----------
    {
      path: "/perfilWebmaster",
      name: "perfiles1",
      component: () => import("./views/Manager/PerfilWebmaster.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > PERFIL WEBMASTER",
      },
    },

    //----------- manager niveles ----------
    {
      path: "/niveles",
      name: "niveles",
      component: () =>
        import("./views/Manager/NivelesyGrados/NivelesyGrados.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE NIVELES Y GRADOS",
      },
    },

    //------------manager areas ----------
    {
      path: "/areas",
      name: "areas",
      component: () => import("./views/Manager/Areas.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE ÁREAS",
      },
    },

    //--------------manager cursos ----------
    {
      path: "/cursos",
      name: "cursos",
      component: Cursos,
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE CURSOS",
      },
    },
    //---------manager competencias ------------------------
    {
      path: "/competencias",
      name: "competencias",
      component: () => import("./views/Manager/Competencia/Competencia.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > COMPETENCIAS",
      },
    },
    //--------------- FIN  MANAGER --------------------

    //---------------------------------------------------
    //--------------- MANTENIMIENTO  O ADMINISTRACION DE SISTEMA COLEGIO --------------------

    //-------tecnico admin  configuracion de colegio ----------

    {
      path: "/configuracionColegio",
      name: "Configuracion Colegio",
      component: () => import("./views/Mantenimiento/ConfigColegio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > PERMISOS ADMINISTRATIVOS",
      },
    },

    //-------mantenimiento niveles y grados ----------

    //---- GENERAL
    {
      path: "/mantenimiento",
      name: "mantenimiento",
      component: () =>
        import("./views/Mantenimiento/NivelesyGrados/NivelesyGrados.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > GESTIÓN DE NIVELES Y GRADOS",
      },
    },

    //-------mantenimiento areas ----------

    //---- GENERAL
    {
      path: "/MantAreas",
      name: "MantAreas",
      component: () => import("./views/Mantenimiento/areas.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONFIGURACIÓN DEL SISTEMA > GESTIÓN DE ÁREAS",
      },
    },

    //-------mantenimiento cursos ----------

    //---- GENERAL
    {
      path: "/Curso",
      name: "Curso",
      component: () => import("./views/Mantenimiento/cursos.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONFIGURACIÓN DEL SISTEMA > GESTIÓN DE CURSOS",
      },
    },

    //-------mantenimiento admin perfiles ----------
    {
      path: "/perfiles",
      name: "perfiles2",
      component: () => import("./views/Mantenimiento/Perfiles.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONFIGURACIÓN DEL SISTEMA > PERMISOS DE USUARIOS",
      },
    },

    //-------mantenimiento configuracion escala evaluativa ----------
    {
      path: "/ConfiguracionEscEval",
      name: "/ConfiguracionEscEval",
      component: () =>
        import(
          "./views/Mantenimiento/ConfiguracionEscalaEvaluativa/ConfiguracionEscalaEvaluativa.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > CONFIGURACIÓN DE LA ESCALA EVALUATIVA",
      },
    },

    //------- mantenimiento Competencias, Capacidades y Desempeños del Colegio----------
    {
      path: "/competenciaColegio",
      name: "Competencia Colegio",
      component: () =>
        import("./views/Mantenimiento/Competencia/CompetenciaColegio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > COMPETENCIAS, CAPACIDADES Y DESEMPEÑOS",
      },
    },

    //------- Configuración de Admisión del Colegio----------
    {
      path: "/admision",
      name: "Configuración de admisión",
      component: () =>
        import("./views/Admision/Configuracion/AdmisionColegio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > CONFIGURACIÓN DE ADMISIÓN",
      },
    },

    //------- Relación de postulantes----------
    {
      path: "/relacionPostulantes",
      name: "Relación de Postulantes",
      component: () =>
        import(
          "./views/Mantenimiento/RelacionPostulantes/RelacionPostulantes.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "CONFIGURACIÓN DEL SISTEMA > RELACIÓN DE POSTULANTES",
      },
    },
    //--------------- FIN  MANTENIMIENTO --------------------

    // ------------------------------------------------------------------------------
    //--------------- TECNICO ADMINISTRATIVO   (ADMINISTRACION COLEGIO) -------------

    //-------tecnico admin Mi colegio ----------
    {
      path: "/colegio",
      name: "colegio",
      component: () => import("./views/Administrativo/MiColegio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > MI COLEGIO",
      },
    },

    //-------tecnico admin periodos y año lectivo ----------
    {
      path: "/periodos",
      name: "periodos",
      component: () =>
        import("./views/Administrativo/PeriodosAnosLectivos.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > AÑO LECTIVO, PERIODOS Y CALENDARIO ACADÉMICO",
      },
    },

    //---------coordinaciones-------------
    {
      path: "/coordinaciones",
      name: "coordinaciones",
      component: () =>
        import("./views/Administrativo/Coordinaciones/Coordinaciones.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > COORDINACIONES",
      },
    },

    //---------migración de datos ------------------------
    {
      path: "/migracionDatos",
      name: "Migración de Datos",
      component: () =>
        import("./views/Administrativo/MigracionDeDatos/MigracionDeDatos.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > MIGRACIÓN DE DATOS",
      },
    },

    //-------  usuarios ----------
    {
      path: "/usuarios",
      name: "usuarios1",
      component: () => import("./views/Mantenimiento/Usuarios.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > GESTIÓN DE USUARIOS",
      },
    },

    // ------------------  Manual de convivencia  ----------------------
    {
      path: "/manualconvivencia",
      name: "manualconvivencia",
      component: () =>
        import("./views/Administrativo/ManualConvivencia/index.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > CONFIGURACIÓN DEL MANUAL DE CONVIVENCIA",
      },
    },

    //-------tecnico admin niveles y grados  ----------
    {
      path: "/admingrados",
      name: "admingrados",
      component: () =>
        import("./views/Administrativo/NivelesyGrados/adminGrados.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > NIVELES Y GRADOS",
      },
    },

    //-------tecnico admin registro de personal ----------
    {
      path: "/registroPersonal",
      name: "registroPersonal",
      component: () =>
        import("./views/Administrativo/RegistroPersonal/registroPersonal.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > RR. HH.: REGISTRO DE PERSONAL",
      },
    },

    //-------tecnico admin registro de alumno y familiar---------
    {
      path: "/registroacademico",
      name: "registroacademico",
      component: () =>
        import(
          "./views/Administrativo/RegistroAcademico/RegistroAcademico.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > MATRÍCULA DEL ESTUDIANTE Y REGISTRO FAMILIAR",
      },
    },

    {
      path: "/registroacademico/alumno/",
      name: "registroacademico_alumno_crear",
      component: () =>
        import("./views/Administrativo/RegistroAcademico/RegistrarAlumno.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > MATRÍCULA DEL ESTUDIANTE Y REGISTRO FAMILIAR",
      },
    },

    {
      path: "/registroacademico/alumno/:id",
      name: "registroacademico_alumno_editar",
      component: () =>
        import("./views/Administrativo/RegistroAcademico/RegistrarAlumno.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > MATRÍCULA DEL ESTUDIANTE Y REGISTRO FAMILIAR",
      },
    },
    {
      path: "/registroacademico/familiar/alumno/:idAlumno",
      name: "registroacademico_familiar_crear",
      component: () =>
        import(
          "./views/Administrativo/RegistroAcademico/RegistrarFamiliar.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > MATRÍCULA DEL ESTUDIANTE Y REGISTRO FAMILIAR",
      },
    },
    {
      path: "/registroacademico/familiar/:idFamiliar/alumno/:idAlumno",
      name: "registroacademico_familiar_editar",
      component: () =>
        import(
          "./views/Administrativo/RegistroAcademico/RegistrarFamiliar.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "ADMINISTRACIÓN DE COLEGIO > MATRÍCULA DEL ESTUDIANTE Y REGISTRO FAMILIAR",
      },
    },

    //-------tecnico admin departamentos ----------
    {
      path: "/carpeta_estudiante",
      name: "carpeta_estudiante",
      component: () =>
        import("./views/CarpetaEstudiante/CarpetaEstudiante.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > CARPETA DEL ESTUDIANTE",
      },
    },

    //-------tecnico admin areas ----------
    {
      path: "/adminareas",
      name: "adminareas",
      component: Adminareas,
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > ÁREAS",
      },
    },

    //-------tecnico admin cursos ----------
    {
      path: "/admincursos",
      name: "admincursos",
      component: () => import("./views/Administrativo/Cursos.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > CURSOS",
      },
    },

    //-------tecnico admin secciones ----------
    {
      path: "/secciones",
      name: "secciones",
      component: Secciones,
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > SECCIONES",
      },
    },

    //-------tecnico admin asignacion cursos ----------
    {
      path: "/asignacion",
      name: "asignacion",
      component: () => import("./views/Administrativo/asignacionCursos.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > ASIGNACIÓN DE CURSOS",
      },
    },

    //-------tecnico admin asignacion docente ----------
    {
      path: "/asignacionTemario",
      name: "asignacionTemario",
      component: () =>
        import(
          "./views/Administrativo/AsignacionDocente/asignacionTemario.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DE COLEGIO > ASIGNACIÓN TEMARIO",
      },
    },

    //--------------- FIN TECNICO ADMINISTRATIVO --------------------

    //--------------- ACADEMICO --------------------

    //------- academico Programacion Docente ----------

    //------- GENERAL
    {
      path: "/progDocente",
      name: "progDocente",
      component: () =>
        import("./views/Academico/ProgramacionDocente/ProgramacionDocente.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > PROGRAMACIÓN DOCENTE",
      },
    },

    //------- ECUADOR
    {
      path: "/progDocenteEc",
      name: "progDocenteEc",
      component: () =>
        import(
          "./views/Academico/ProgramacionDocente/ProgramacionDocenteEc.vue"
        ),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > PROGRAMACIÓN DOCENTE",
      },
    },   

    //---------- gestion contenido colegio
    {
      path: "/gestionContenidoColegio",
      name: "gestionContenidoColegio",
      component: () =>
        import("./views/GestorContenido/Colegio/unidad/unidad.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > GESTIÓN DE CONTENIDOS",
      },
    },

    //------- academico malla curricular ----------
    {
      path: "/mallaCurricular",
      name: "mallaCurricular",
      component: () => import("./views/Academico/MallaCurricular.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MALLA CURRICULAR",
      },
    },

    //------- academico alumno Clases ----------
    {
      path: "/alumnoClase",
      name: "alumnoClase",
      component: () => import("./views/Academico/Alumno/Clase.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MIS CLASES",
      },
    },

    //------- academico alumno Clases ----------
    {
      path: "/alumnoActividades",
      name: "alumnoActividades",
      component: () => import("./views/Academico/Alumno/Actividades.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MIS ACTIVIDADES",
      },
    },

    //---------academico gestion de cordinacion-------------
    {
      path: "/gestionCoordinacion",
      name: "gestionCoordinacion",
      component: () =>
        import("./views/Academico/GestionCoordinacion/GestionCoordinacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > Supervisión docente (coordinador)",
      },
    },

    {
      //-------acadenico gestion de clases de coordinacion  ------
      path: "/clasesCoordinacion",
      name: "clasesCoordinacion",
      component: () =>
        import("./views/Academico/GestionCoordinacion/ClasesCoordinacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > Supervisión de clases (coordinador)",
      },
    },

    {
      //-------acadenico gestion de tareas de coordinacion  ------
      path: "/tareasCoordinacion",
      name: "tareasCoordinacion",
      component: () =>
        import("./views/Academico/GestionCoordinacion/TareasCoordinacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > SUPERVISIÓN ESTUDIANTE (COORDINADOR)",
      },
    },

    {
      //-----------academico gestion de direccion -------
      path: "/gestionDireccion",
      name: "gestionDireccion",
      component: () =>
        import("./views/Academico/GestionDireccion/GestionDireccion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > Supervisión docente (Director)",
      },
    },

    {
      //-----------academico gestion de direccion de clases -------
      path: "/clasesDireccion",
      name: "clasesDireccion",
      component: () =>
        import("./views/Academico/GestionDireccion/ClasesDireccion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > Supervisión de clases (Director)",
      },
    },

    {
      //-----------academico gestion de direccion de tareas -------
      path: "/tareasDireccion",
      name: "tareasDireccion",
      component: () =>
        import("./views/Academico/GestionDireccion/TareasDireccion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > Supervisión Estudiante (Director)",
      },
    },

    {
      //-----------academico gestion de direccion de tareas -------
      path: "/enfoquesTransversales",
      name: "enfoquesTransversales",
      component: () => import("./views/Academico/EnfoquesLink.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > ENFOQUES TRANSVERSALES",
      },
    },

    {
      //-----------academico gestion de direccion de tareas -------
      path: "/competenciasDesemp",
      name: "competenciasDesemp",
      component: () => import("./views/Academico/CompetenciasLink.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > COMPETENCIAS, CAPACIDADES Y DESEMPEÑOS",
      },
    },

    {
      //-----------academico gestion de clases padre de familia -------
      path: "/clasesAlumnoFamilia",
      name: "clasesAlumnoFamilia",
      component: () =>
        import("./views/Academico/GestionFamilia/ClasesFamilia.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > CLASES DEL ESTUDIANTE",
      },
    },
    {
      //-----------academico gestion de actividades padre de familia -------
      path: "/asistenciaColegio",
      name: "Registro de asistencia al colegio",
      component: () => import("./views/Academico/AsistenciaColegio/AsistenciaColegio.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "EVALUACIÓN > REGISTRO DE ASISTENCIA AL COLEGIO",
      },
    },

    {
      //-----------academico gestion de actividades padre de familia -------
      path: "/actividadesAlumnoFamilia",
      name: "actividadesAlumnoFamilia",
      component: () =>
        import("./views/Academico/GestionFamilia/ActividadesFamilia.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > ACTIVIDADES DEL ESTUDIANTE",
      },
    },

    {
      //-----------academico listado de docentes -------
      path: "/listadoDocente",
      name: "listadoDocente",
      component: () =>
        import("./views/Academico/GestionDocente/ListadoDocente.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > LISTADO DE DOCENTES",
      },
    },

    {
      //-----------academico listado de docentes -------
      path: "/listadoEstudianteSecion",
      name: "listadoEstudianteSecion",
      component: () => import("./views/Academico/Alumno/ListadoAlumno.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MIS COMPAÑEROS",
      },
    },

    {
      //-----------academico listado de docentes -------
      path: "/listadoDocenteEstudiante",
      name: "listadoDocenteEstudiante",
      component: () => import("./views/Academico/Alumno/ListadoDocente.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MIS DOCENTES",
      },
    },

    {
      //-----------academico listado de docentes -------
      path: "/listadoDocentePadreFamilia",
      name: "listadoDocentePadreFamilia",
      component: () =>
        import("./views/Academico/GestionFamilia/ListadoDocente.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > LISTADO DE DOCENTES PADRE DE FAMILIA",
      },
    },

    {
      //-----------academico listado de docentes -------
      path: "/programarReunion",
      name: "Progrmar Reunion",
      component: () =>
        import("./views/Academico/ProgramarReunion/progarmarReunion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > PROGRAMAR REUNIÓN",
      },
    },
    //--------------- FIN ACADEMICO -------------------

    //--------------- EVALUACION --------------------

    //------- academico gestion de evaluacion ----------
    {
      path: "/gestionEvaluacion",
      name: "gestionEvaluacion",
      component: () =>
        import("./views/Academico/GestionEvaluacion/gestionEvaluacion.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > GESTIÓN DE EVALUACIÓN",
      },
    },

    //------- Programacion de Evaluacion   ----------
    {
      path: "/progEvaluacion",
      name: "Programación de Evaluación ",
      component: () => import("./views/Evaluacion/Evaluacion.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "EVALUACIÓN > PROGRAMACIÓN DE EVALUACIÓN",
      },
    },

    //------- evaluacion registro anecdotico ----------
    {
      path: "/registroAnecdotico",
      name: "registroAnecdotico",
      component: () => import("./views/Evaluacion/RegistroAnecdotico.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONDUCTA > REGISTRO ANECDÓTICO",
      },
    },

    //------- evaluacion registro anecdotico coordinador ----------
    {
      path: "/registroAnecdoticoCoordinador",
      name: "registroAnecdoticoCoordinador",
      component: () => import("./views/Evaluacion/AnecdoticoCordinador.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONDUCTA > REGISTRO ANECDÓTICO COORDINADOR",
      },
    },

    //------- evaluacion registro anecdotico coordinador ----------
    {
      path: "/incidenciaConductual",
      name: "incidenciaConductual",
      component: () =>
        import("./views/Evaluacion/IncidenciaConductual/conductual.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONDUCTA > REGISTRO DE INCIDENCIAS CONDUCTUALES",
      },
    },

    // --------------------- Registro Conductuales  ---------------------------
    {
      path: "/registroconductuales",
      name: "Registro Conductual",
      component: () =>
        import("./views/Evaluacion/RegistroConductuales/regConductual.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "CONDUCTA > REGISTRO CONDUCTUALES",
      },
    },

    //------- evaluacion Alumno ----------
    {
      path: "/alumnoEval",
      name: "Mis Evaluaciones",
      component: () =>
        import("./views/Evaluacion/AlumnoEvaluacion/alumnoEval.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "EVALUACIÓN > MIS EVALUACIONES",
      },
    },

    //------- Programacion de Evaluacion   ----------
    {
      path: "/libretaNotas",
      name: "Libreta de Notas",
      component: () =>
        import("./views/Evaluacion/LibretaDeNotas/LibretaDeNotas.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "EVALUACIÓN > LIBRETA DE NOTAS",
      },
    },

    //--------------- FIN EVALUACION --------------------

    //--------------- RECURSOS DIGITALES --------------------
    {
      path: "/planLector",
      name: "Plan Lector",
      component: () =>
        import("./views/RecursosDigitales/planLector/planLector.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITAL > PLAN LECTOR",
      },
    },

    {
      path: "/simuladores",
      name: "simuladores",
      component: () => import("./views/RecursosDigitales/simuladores.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > SIMULADORES INTERACTIVOS",
      },
    },

    {
      path: "/libroVirtual",
      name: "Libro virtual",
      component: () =>
        import("./views/RecursosDigitales/libroVirtual/libroVirtual.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > LIBRO VIRTUAL / LIBRO DE ACTIVIDADES",
      },
    },
    {
      path: "/libroVirtualGrado",
      name: "libroVirtualGrado",
      component: () =>
        import("./views/RecursosDigitales/libroVirtual/libroVirtualGrado.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > LIBRO VIRTUAL",
      },
    },
    {
      path: "/libroVirtualVista",
      name: "libroVirtualVista",
      component: () =>
        import("./views/RecursosDigitales/libroVirtual/libroVirtualVista.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > LIBRO VIRTUAL",
      },
    },
    {
      path: "/gymvirtual",
      name: "gymvirtual",
      component: () =>
        import("./views/RecursosDigitales/gymvirtual/gymvirtual.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GYM VIRTUAL",
      },
    },
    {
      path: "/gymVirtualVista",
      name: "gymVirtualVista",
      component: () =>
        import("./views/RecursosDigitales/gymvirtual/gymVirtualVista.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GYM VIRTUAL",
      },
    },

  {
    path: "/gymVirtualList",
    name: "gymVirtualList",
    component: () =>
      import("./views/RecursosDigitales/gymvirtual/gymVirtualList.vue"),
    meta: {
      autentificado: true,
      layout: "adm_academico_layout",
      breadCrumb: "RECURSOS DIGITALES > GYM VIRTUAL",
    },
  },
    {
      path: "/googleEarth",
      name: "Google Earth",
      component: () => import("./views/RecursosDigitales/googleEarth.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GOOGLE EARTH",
      },
    },

    {
      path: "/LibroTotal",
      name: "Libro Total",
      component: () => import("./views/RecursosDigitales/libroTotal.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb:
          "RECURSOS DIGITALES > EL LIBRO TOTAL: BIBLIOTECA LATINOAMERICANA y UNIVERSAL ",
      },
    },

    /*
    {
      path: "/Gamificacion",
      name: "Gamificación",
      //component: () => import("./views/RecursosDigitales/gamificacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GAMIFICACIÓN",
        redirect:
          "https://kahoot.com/?utm_name=controller_app&utm_source=controller&utm_campaign=controller_app&utm_medium=link",
      },
      beforeEnter: (to, from, next) => {
        console.log(to);
        if (to.meta.redirect != undefined && to.meta.redirect) {
          window.open(to.meta.redirect, "_blank");
        } else {
          next();
        }
      },
    },
    */

    {
      path: "/Gamificacion",
      name: "Gamificación",
      component: () => import("./views/RecursosDigitales/gamificacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GAMIFICACIÓN",
      },
    },

    {
      path: "/Gamificacion-alumno",
      name: "Gamificación Alumno",
      component: () =>
        import("./views/RecursosDigitales/gamificacion-alumno.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GAMIFICACIÓN ESTUDIANTE",
      },
    },

    {
      path: "/GoogleMaps",
      name: "Google Maps",
      component: () => import("./views/RecursosDigitales/googleMaps.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GOOGLE MAPS",
      },
    },
    //--------------- FIN RECURSOS DIGITALES --------------------

    //--------------- GESTION CURRICULAR --------------------
    //-------gestion curric contenidos clicken1 ----------

    {
      path: "/contenidoclases",
      name: "contenidoclases",
      component: () =>
        import("./views/Manager/GestionContenido/unidad/unidad.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "MÁNAGER > GESTIÓN DE CONTENIDOS",
      },
    },



    //-------Creador de Contenido Alberto ---------->
    {
      path: "/creador",
      name: "creador",
      component: CreadordeContenido,
      meta: {
        autentificado: false,
        layout: "adm_academico_layout",
        breadCrumb: "CREADOR",
      },
    },
    //-------Diapositivas ----------
    {
      path: "/diapositivas",
      name: "diapositivas",
      component: () =>
        import("./views/ContenidoDiapositivas/ContenidoDiapositiva.vue"),

      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "DIAPOSITIVAS",
      },
    },
    {
      path: "/visor",
      name: "visordecontenido",
      component: () => import("./views/VisordeContenido.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "VISOR",
      },
    },

    //-------Reportes ----------
    {
      path: "/formatoReporte",
      name: "FormatoReportes",
      component: () => import("./views/Reporte/formatoReporte.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "REPORTES > FORMATO REPORTES",
      },
    },  
    // INICIO DE COSAS QUE NO SIRVEN 
    {
      path: "/cge",
      name: "cge",
      component: () => import("./views/cabeceraGestionEvaluativa.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "Gestionar Evaluaciones",
      },
    },

    {
      path: "/sci",
      name: "sci",
      component: () => import("./views/seleccionIndicadores.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "Seleccion de Indicadores",
      },
    },

    {
      path: "/sci2",
      name: "sci2",
      component: () => import("./views/seleccionCompetenciaDesempeño.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "Seleccion de Indicadores",
      },
    },
    
    {
      path: "/tesoreria/configuracion",
      name: "teso_config",
      component: () =>
        import("./views/Tesoreria/Configuracion/Configuracion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "TESORERIA > CONFIGURACION",
      },
    },
    {
      path: "/tesoreria/asignacion",
      name: "teso_asig",
      component: () => import("./views/Tesoreria/Asignacion/Asignacion.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "TESORERIA > ASIGNACION",
      },
    },
    {
      path: "/tesoreria/registro",
      name: "teso_reg",
      // name: "teso_asig",
      component: () => import("./views/Tesoreria/Registro/Registro.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "TESORERIA > REGISTROS",
      },
    },
    {
      path: "/tesoreria/pago",
      name: "teso_pago",
      component: () => import("./views/Tesoreria/Pago/Pago.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "TESORERIA > PAGOS",
      },
    },

    //--------------------------------------------------------
    //------------ RUTAS SIMULADORES DE EXAMENES--------------
    //--------------------------------------------------------
    {
      // MANAGER
      path: "/gestionar_simulador",
      name: "simuladorp",
      component: () =>
        // import("./views/SimuladorExamenes/manager/componentes/listaBalotarios.vue"),
        import("./views/SimuladorExamenes/manager/simuladorManager.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GESTION DEL SIMULADOR",
      },
    },
    {
      // RUTA PADRE DEL PADRE :P
      path: "/simulador_familia",
      component: () =>
        import("./views/SimuladorExamenes/simuladorPrincipal.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "RECURSOS DIGITALES > GESTION DEL SIMULADOR",
      },
      children: [
        // RUTAS HIJAS DEL PADRE
        {
          name: "simuladorFamiliaInit",
          path: "",
          component: () =>
            import(
              "./views/SimuladorExamenes/padreFamilia/simuladorPadreFamilia.vue"
            ),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > INICIAL",
          },
        },
        {
          name: "simuladorFamiliaLista",
          path: "/lista_familia_simuladores",
          component: () =>
            import(
              "./views/SimuladorExamenes/padreFamilia/simuladorPadreFamiliaLista.vue"
            ),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > LISTA",
          },
        },
      ],
    },
    {
      // RUTA PADRE DEL DOCENTE
      path: "/gestionSimulador",
      component: () =>
        import("./views/SimuladorExamenes/simuladorPrincipal.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADEMICO > GESTION DEL SIMULADOR",
      },
      children: [
        // RUTAS HIJAS DEL DOCENTE
        {
          name: "simuladorDocenteInit",
          path: "",
          component: () =>
            import("./views/SimuladorExamenes/docente/simuladorDocente.vue"),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > INICIAL",
          },
        },
        {
          name: "simuladorDocenteLista",
          path: "/lista_docente_simuladores",
          component: () =>
            import(
              "./views/SimuladorExamenes/docente/simuladorDocenteLista.vue"
            ),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > LISTA",
          },
        },
      ],
    },
    {
      // RUTA RAIZ DEL ESTUDIANTE
      path: "/mis_simuladores",
      component: () =>
        import("./views/SimuladorExamenes/simuladorPrincipal.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADEMICO > MIS SIMULADORES",
      },
      children: [
        // RUTAS HIJAS DEL ESTUDIANTE
        {
          name: "simuladorEstudianteInit",
          path: "",
          component: () =>
            import(
              "./views/SimuladorExamenes/estudiante/simuladorEstudiante.vue"
            ),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > INICIAL",
          },
        },
        {
          name: "simuladorEstudianteList",
          path: "/lista_simuladores",
          component: () =>
            import(
              "./views/SimuladorExamenes/estudiante/simuladorEstudianteLista.vue"
            ),
          meta: {
            layout: "adm_academico_layout",
            breadCrumb: "ACADEMICO > MIS SIMULADORES > LISTA",
          },
        },
      ],
    },
    // SIMULADORES - RUTA MODIFICADA DE PROG DOCENTE PARA ENVIAR CON PARAMETROS JAAC
    {
      path: "/progDocente/:value",
      name: "progDocenteValor",
      component: () =>
        import("./views/Academico/ProgramacionDocente/ProgramacionDocente.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > PROGRAMACIÓN DOCENTE",
      },
    },
    // SIMULADORES - RUTA MODIFICADA DE PROG ALUMNO PARA ENVIAR CON PARAMETROS JAAC
    {
      path: "/alumnoClase/:value",
      name: "alumnoClaseValor",
      component: () => import("./views/Academico/Alumno/Clase.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > MIS CLASES",
      },
    },
    // SIMULADORES - RUTA MODIFICADA DE CLASE ALUMNO PADRE PARA ENVIAR CON PARAMETROS JAAC
    {
      path: "/clasesAlumnoFamilia/:value",
      name: "clasesAlumnoFamiliaValor",
      component: () =>
        import("./views/Academico/GestionFamilia/ClasesFamilia.vue"),
      meta: {
        autentificado: true,
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > CLASES DEL ESTUDIANTE",
      },
    },
    //--------------------------------------------------------------------------------
    //---------- RUTA CIERRE DEL AÑO && SITUACIÓN DEL ESTUDIANTE ---------------------
    //--------------------------------------------------------------------------------

    {
      name: "Cierre del año",
      path: "/cierreanio",
      component: () =>
        import("./views/CierreAnio/CierreAnio.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "ADMINISTRACIÓN DEL COLEGIO > CIERRE DEL AÑO",
      },
    },
    //--------------------------------------------------------------
    //------------------- MÉTRICAS DEL COLEGIO ---------------------
    //--------------------------------------------------------------
    {
      name: "Métricas generales",
      path: "/metricasgenerales",
      component: () =>
        import("./views/Metricas/MetricasGenerales/MetricasGenerales.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "MÉTRICAS DEL COLEGIO > MÉTRICAS GENERALES",
      },
    },
    {
      name: "Métricas del Estudiante",
      path: "/metricasestudiante",
      component: () =>
        import("./views/Metricas/MetricasEstudiante/MetricasEstudiante.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "MÉTRICAS DEL COLEGIO > MÉTRICAS DEL ESTUDIANTE",
      },
    },
    {
      name: "Métricas del docente",
      path: "/metricasdocente",
      component: () =>
        import("./views/Metricas/MetricasDocente/MetricasDocente.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "MÉTRICAS DEL COLEGIO > MÉTRICAS DEL DOCENTE",
      },
    },


    //--------------------------------------------------------------
    //---------- RUTA VER LOS COMPONENTES Y ESTILOS DE LA PLATAFORMA  ---------------------
    //--------------------------------------------------------------
    {
      name: "DEV STYLE standardized",
      path: "/DevStyle",
      component: () =>import("./views/Dev/DevStyle.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "ACADEMICO > MIS SIMULADORES > INICIAL",
      },
    },

    {
      name: "evalAlumnoFamilia",
      path: "/evalAlumnoFamilia",
      component: () =>import("./views/Academico/EvaluacionesAlumnoFamilia/evaluacionesAlumnoFamilia.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "ACADÉMICO > EVALUACIONES DEL ESTUDIANTE",
      },
    },
      // Este es la ruta del horario automatico
    {
        name: "configuracionDocente",
        path: "/configuracionDocente",
        component: () =>import("./views/Horario/configuraciondocente/configuracionDocente.vue"),
        meta: {
          layout: "adm_academico_layout",
          breadCrumb: "HORARIO > CONFIGURACION DEL DOCENTE",
        },
    },

    {
      name: "horarioAutomatico",
      path: "/horarioAutomatico",
      component: () =>import("./views/Horario/horarioautomatico/horarioautomatico.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "HORARIO > HORARIO AUTOMÁTICO",
      },
    },

    {
      name: "horarioManual",
      path: "/horarioManual",
      component: () =>import("./views/Horario/horariomanual/horariomanual.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "HORARIO > HORARIO MANUAL",
      },
    },
      // Ruta para la carga del docente
    {
      name: "cargaDocente",
      path: "/cargaDocente",
      component: () =>import("./views/Horario/cargaDocente/cargadocente.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "HORARIO > CARGA DOCENTE",
      },
    } ,
    {
      name: "postergacionNotas",
      path: "/postergacionNotas",
      component: () =>import("./views/Evaluacion/PostergacionDelAlumno/postergacion.vue"),
      meta: {
        layout: "adm_academico_layout",
        breadCrumb: "EVALUACIÓN > POSTERGACIÓN DE NOTAS",
      },
    } ,
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.autentificado && !sessionStorage.autentificado) {
    next("login");
  } else {
    next();
  }
});

export default router;
